
import Alpine from "alpinejs";

import intlTelInput from 'intl-tel-input';
import 'intl-tel-input/build/css/intlTelInput.css';
import 'intl-tel-input/build/js/utils.js';


document.addEventListener('alpine:init', () => {
    Alpine.data('initRegister', (params) => ({
        phoneValue:'+1',
        params:params,
        inputShow:{},
        btnLoadingBlock:false,
        btnLoading:false,
        onSubmit() {
            if (!this.btnLoadingBlock) {
                this.btnLoading=true;
            }
            this.params.registerForm.submit();
        },
        skipAndSubmit() {
            this.params.registerForm.submit();
        },
        initializelTelInput(initialCountry=null) {

            let params = {
                autoInsertDialCode:true,
                nationalMode: false,
                //utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@18.2.1/build/js/utils.js",
            };
            if (initialCountry && this.params.isoCountryCode) {
                params['initialCountry'] = this.params.isoCountryCode.value;
            }
            let select = intlTelInput(this.params.phone_number, params);
            return select;
        },
        initialize() {
            if (this.params.phone_number) {
                let initialCountry = null;
                if (this.params.country && this.params.country.value=='') {
                    this.params.country.value = this.params.isoCountryCode.value;
                    initialCountry = this.params.isoCountryCode.value;
                }
                this.initializelTelInput(initialCountry);
            }
        },
        onChange(paramsName, value) {
            if (this.params[paramsName]) {
                this.inputShow[paramsName] = this.params[paramsName].value==value;
            }
        },
        onShow(paramsName,defaultValue=false) {
            if (!this.inputShow[paramsName]) {
                this.inputShow[paramsName] = defaultValue;
            }
            return this.inputShow[paramsName];
        }
    }))
});
